angular.module('picmonicng').directive('severityButtons', [
  function () {
    return {
      restrict: 'E',
      template:
        '<div class="flex-box flex-align-items-center flex-justify-content-space-between"><a class="pls-btn pls-btn--severity-{{button}}" ng-repeat="button in buttons" ng-click="setSeverity(button)" ng-class="{\'pls-white pls-btn--outline-white\': model !== button && theme === \'dark\', \'pls-blue-steel pls-btn--outline-blue-steel\': model !== button && theme === \'light\', \'pls-btn--selected\': model === button}">{{button}}</a></div>',
      scope: {
        model: '=',
        theme: '@',
      },
      controller: [
        '$scope',
        function ($scope) {
          $scope.buttons = ['Low', 'Medium', 'High'];
          $scope.theme = $scope.theme || 'dark';

          $scope.setSeverity = function (severity) {
            $scope.model = severity;
          };
        },
      ],
    };
  },
]);
